'use client';

import { createContext, use } from 'react';
import type { FieldChange } from '@/lib/services/ai-analysis';

/**
 * Context that provides field-level change info to FormField components
 * when rendering inside an update review card.
 *
 * When set, FormField will:
 * - Render enrichment fields with blue text + NEW tag
 * - Hide conflict fields (they're rendered in the ConflictDiffFooter instead)
 */
const FieldChangesContext = createContext<Record<string, FieldChange> | null>(
  null
);

export const FieldChangesProvider = FieldChangesContext.Provider;

export function useFieldChanges() {
  return use(FieldChangesContext);
}
